import { IOnInit } from "angular";

export class MachineProgressiveGameDetailViewDetailGameViewComponentController
  implements IOnInit
{
  $onInit(): void {}
}
